<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import ItemCategory from "@/components/modals/item-category.vue";
import Unit from "@/components/modals/unit.vue";
import ItemCards from "@/router/views/office/office-widgets/item-cards.vue";
import RequestItems from "@/router/views/office/office-widgets/request-items.vue";
import CartItems from "@/router/views/office/office-widgets/cart-items.vue";
import ItemLogs from "@/components/modals/item-request-logs.vue";
import Swal from "sweetalert2";
import { cloneDeep } from 'lodash';

export default {
    page: {
        title: "Item List",
    },
    components: {
        Layout,
        PageHeader,
        MaskedInput,
        ItemCategory,
        Unit,
        ItemCards,
        RequestItems,
        ItemLogs,
        CartItems
    },
    data() {
        return {
            title: "Item List",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Item List",
                    active: true,
                },
            ],
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            tableData: [],
            form: {
                id: 0,
                itemName: "",
                description: "",
                unitId: "",
                itemCategoryId: "",
                unitCost: "",
                subType: "",
            },
            itemCategory: "",
            unit: "",
            pendingLoading: false,
            pending: [],
            approveLoading: false,
            approved: [],
            returnedLoading: false,
            returned: [],
            activeTab: 0,
            categories: [],
            carts: [],
            returnCount: 0,
            searchItem: null,
            remainingResult: 0,
            tableBusy: false,
            startPage: 0,
            loadingMore: false,
        };
    },
    validations: {
        form: {
            itemName: { required },
            description: { required },
            unitId: { required },
            itemCategoryId: { required },
            unitCost: { required },
            subType: { required },
        },
    },
    async created() {
        await this.changeCycle(this.$store.state.data.cycle);
        await this.getItemCategories();
        // await this.getCartItems(this.$store.state.data.selectedDepartment.id);
        let dashboardData = JSON.parse(localStorage.getItem('dashboardData'));
        // this.returnCount = !dashboardData ? 0 : dashboardData.returnedItemRequests
    },
    computed: {
        selectedAvailableItems(){
            return this.tableData.filter((item) => {
                return item.selected;
            });
        },
        viewOnly(){
            let admin = this.$store.state.decrypt.isAdmin();
            if(admin){
                return false;
            }
            let accessList = this.$store.state.decrypt.userAccessList();
            let access = accessList.find((x) => x.Access.toLowerCase() === 'purchase request' && x.Type.toLowerCase() === 'delivery unit')
            return access ? false : true;
        }
    },
    methods: {
        async getCartItems(id){
            await this.$store
                .dispatch("deliveryunititemcart/GetDeliveryUnitItemCartByDU", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.filterKey = `${item.item.itemName} ${item.item.description}`;
                    })
                    this.carts = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getItemCategories(){
            await this.$store
                .dispatch("itemcategory/GetItemCategory")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.categories = res.data.sort((a, b) => {
                        return a.name.localeCompare(b.name);
                    });
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async changeCycle(cycle){
            if(!this.searchItem) return;
            this.tableBusy = true;
            await this.getItems(cycle)
            this.tableBusy = false;
        },
        async getItems(cycle){
            this.tableData = [];
            this.tableBusy = true;
            this.remainingResult = 0;
            if(this.searchItem && this.searchItem.search.trim() == ""){
                this.tableBusy = false;
                return;
            }
            await this.$store
                .dispatch("item/SearchItem", {
                    ...this.searchItem,
                    year: cycle,
                    lastId: 0,
                    removeLoading: true,
                    campusId: this.$store.state.data.selectedCampus.id,
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.tableBusy = false;
                    res.data.results.forEach((item) => {
                        item.descriptionClicked = false;
                        item.cost = this.formatCurrency(item.unitCost);
                        item.thumbnailUrl = item.thumbnail ? `${this.$store.state.data.rootFileDirectory}Procurement/${item.thumbnail}` : '';
                        item.filterKey = `${item.itemName} ${item.description}`;
                        item.selected = false;
                        item.trimmedItemName = item.itemName.trim().replace(/\s/g, "")
                    });
                    this.tableData = res.data.results;
                    this.remainingResult = res.data.remainingResult;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast(
                        "Something went wrong! - getting Item",
                        "error"
                    );
                });
        },
        async loadMoreItems(){
            this.startPage++;
            this.loadingMore = true;
            try{
                const { data: response } = await this.$store.dispatch("item/SemanticSearch", {
                    body: this.searchItem.search,
                    page: this.startPage,
                    year: this.$store.state.data.cycle,
                    campusId: this.$store.state.data.selectedCampus.id,
                    removeLoading: true,
                });
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }
                response.results.forEach((item) => {
                    item.descriptionClicked = false;
                    item.cost = this.formatCurrency(item.unitCost);
                    item.thumbnailUrl = item.thumbnail ? `${this.$store.state.data.rootFileDirectory}Procurement/${item.thumbnail}` : '';
                    item.filterKey = `${item.itemName} ${item.description}`;
                    item.selected = false;
                    item.trimmedItemName = item.itemName.trim().replace(/\s/g, "")
                });
                this.tableData = this.tableData.concat(response.results);
                this.remainingResult = response.remainingResult;
            }catch(error){
                this.showToast("Something went wrong! - getting Item", "error");
            }
            this.loadingMore = false;
        },
        onReset() {
            this.form = {
                id: 0,
                itemName: "",
                description: "",
                unitId: "",
                itemCategoryId: "",
                unitCost: "",
                subType: "Goods",
            };
            this.unit = "";
            this.itemCategory = "";
            this.$v.form.$reset();
        },
        requestItem(){
            this.onReset();
            this.$bvModal.show('item-request-modal');
        },
        getUnit() {
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            this.unit = data.unitName;
            this.form.unitId = data.id;
            this.form.unit = data;
        },
        getItemCategory() {
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            this.itemCategory = data.name;
            this.form.itemCategoryId = data.id;
            this.form.itemCategory = data;
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) return;
            var data = cloneDeep(this.form);
            data.itemName = this.form.itemName.trim();
            data.description = this.form.description.trim();
            data.unitCost = this.getExactAmt(this.form.unitCost);
            data.deliveryUnitId = this.$store.state.data.selectedDU.id;
            data.departmentId = this.$store.state.data.selectedDepartment.id;
            if (this.form.id > 0) {
                this.$store
                    .dispatch("itemrequest/UpdateItemRequest", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        if(this.form.type && this.form.type == 'returned'){
                            let index = this.returned.findIndex((x) => x.id == this.form.id);
                            this.returned.splice(index, 1, data);
                            this.activeTab = 3
                        }
                        if(this.form.type && this.form.type == 'pending'){
                            let index = this.pending.findIndex((x) => x.id == this.form.id);
                            this.pending.splice(index, 1, data);
                            this.activeTab = 1
                        }
                        this.onReset();
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast(
                            "Something went wrong! - updating item",
                            "error"
                        );
                    });
            } else {
                this.$store
                    .dispatch("itemrequest/CreateItemRequest", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.itemCategory = JSON.parse(JSON.stringify(this.itemCategory));
                        res.data.unit = JSON.parse(JSON.stringify(this.unit));
                        this.pending.push(res.data);
                        this.onReset();
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast(
                            "Something went wrong! - creating item",
                            "error"
                        );
                    });
            }
            this.submitted = false;
        },
        async getPendingRequest(){
            this.pendingLoading = true;
            await this.$store
                .dispatch("itemrequest/GetDepartmentPendingItemRequest", {
                    departmentId: this.$store.state.data.selectedDepartment.id,
                    cycle: this.$store.state.data.cycle
                })
                .then((res) => {
                    this.pendingLoading = false;
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    res.data.forEach((item) => {
                        item.filterKey = `${item.itemName} ${item.description}`;
                    });
                    this.pending = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong! - getting pending item request",
                        "error"
                    );
                });
            this.pendingLoading = false;
        },
        async getApprovedRequest(){
            this.approveLoading = true;
            await this.$store
                .dispatch("itemrequest/GetDepartmentApprovedItemRequest", {
                    departmentId: this.$store.state.data.selectedDepartment.id,
                    cycle: this.$store.state.data.cycle
                })
                .then((res) => {
                    this.approveLoading = false;
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    res.data.forEach((item) => {
                        item.filterKey = `${item.itemName} ${item.description}`;
                    });
                    this.approved = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong! - getting approved item request",
                        "error"
                    );
                });
            this.approveLoading = false;
        },
        async getReturnedRequest(){
            this.returnedLoading = true;
            await this.$store
                .dispatch("itemrequest/GetDepartmentReturnedItemRequest", this.$store.state.data.selectedDepartment.id)
                .then((res) => {
                    this.returnedLoading = false;
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    res.data.forEach((item) => {
                        item.filterKey = `${item.itemName} ${item.description}`;
                    });
                    this.returned = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong! - getting returned item request",
                        "error"
                    );
                });
            this.returnedLoading = false;
        },
        updatePendingRI(item, type){
            this.form = cloneDeep(item);
            this.form.type = type;
            this.unit = item.unit;
            this.itemCategory = item.itemCategory;
            this.form.unitCost = this.formatNumber(item.unitCost).toString();
            this.activeTab = 0;
        },
        deletePendingRI(item, type){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("itemrequest/RemoveItemRequest", item.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            if(type == 'pending'){
                                let index = this.pending.findIndex((x) => x.id == item.id);
                                this.pending.splice(index, 1);
                            }else{
                                let index = this.returned.findIndex((x) => x.id == item.id);
                                this.returned.splice(index, 1);
                                let dashboardData = JSON.parse(localStorage.getItem('dashboardData'));
                                dashboardData.returnedItemRequests = parseFloat(dashboardData.returnedItemRequests) - 1;
                                this.returnCount--;
                                localStorage.setItem('dashboardData', JSON.stringify(dashboardData));
                                this.attachedDUNotifications(dashboardData);
                            }
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Error deleting accreditor!", "error");
                        });
                }
            });
        },
        selectedItem(item){
            item.selected = !item.selected;
        },
        repostItem(item){
            this.$store
                .dispatch("itemrequest/PostItemRequest", item.id)
                .then((res) => {
                    if(res.data){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.returned.findIndex((x) => x.id == item.id);
                    this.returned.splice(index, 1);
                    let dashboardData = JSON.parse(localStorage.getItem('dashboardData'));
                    dashboardData.returnedItemRequests = parseFloat(dashboardData.returnedItemRequests) - 1;
                    this.returnCount--;
                    localStorage.setItem('dashboardData', JSON.stringify(dashboardData));
                    this.attachedDUNotifications(dashboardData);
                    this.showToast("Successfully reposted!", "success");
                })
                .catch((err) => {
                    this.showToast("Error deleting accreditor!", "error");
                });
        },
        addToCart(){
            Swal.fire({
                text: `Are you sure you want to add ${this.selectedAvailableItems.length} items to your cart?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#9b2ddb",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, add this!",
            }).then(async (result) => {
                if (result.value) {
                    let items = [];
                    this.selectedAvailableItems.map(item => {
                        items.push({
                            itemId: item.id,
                            deliveryUnitId: this.$store.state.data.selectedDU.id
                        })
                    })
                    let error = 0;
                    for await(const x of items){
                        await this.$store
                            .dispatch("deliveryunititemcart/CreateDeliveryUnitItemCart", x)
                            .then((res) => {
                                if (res.data.error) {
                                    return error++;
                                }
                                this.carts.push({...res.data, filterKey: `${x.itemName} ${x.description}`});
                            })
                            .catch((err) => {
                                error++;
                            });
                    }
                    if(error > 0){
                        return this.showToast("Something went wrong!", "error");
                    }else{
                        this.showToast("Successfully added to cart!", "success");
                        this.selectedAvailableItems.map(item => {
                            item.selected = false;
                        })
                    }
                }
            });
        },
        viewLog(item){
            var logs = JSON.parse(item.returnRemarks);
            logs.map(item => {
                item.dateWTime = this.formatDateWithTime(
                    new Date(item.date)
                );
                item.splitted = item.dateWTime.split(" at ");
            })
            this.$refs.itemLogs.getData(logs);
            this.$bvModal.show('item-request-logs-modal');
        },
        showCart(){
            this.$bvModal.show('cart-items-modal');
        },
        deleteItem(item){
            this.$store
                .dispatch("deliveryunititemcart/DeleteDeliveryUnitItemCart", item.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.carts.findIndex((x) => x.id == item.id);
                    this.carts.splice(index, 1);
                    this.showToast("Successfully deleted!", "success");
                })
                .catch((err) => {
                    this.showToast("Error removing!", "error");
                });
        },
        async searchAction(search){
            this.searchItem = search;
            // this.getItems(this.$store.state.data.cycle);
            this.tableBusy = true;
            this.tableData = [];
            this.startPage = 0;
            this.remainingResult = 0;
            await this.semanticSearch(search);
            this.tableBusy = false;
        },
        async semanticSearch(search){
            try{
                const { data: response } = await this.$store.dispatch("item/SemanticSearch", {
                    body: search.search,
                    year: this.$store.state.data.cycle,
                    campusId: this.$store.state.data.selectedCampus.id,
                    removeLoading: true,
                });
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }
                this.tableData = response.results.map((item) => {
                    item.descriptionClicked = false;
                    item.cost = this.formatCurrency(item.unitCost);
                    item.thumbnailUrl = item.thumbnail ? `${this.$store.state.data.rootFileDirectory}Procurement/${item.thumbnail}` : '';
                    item.filterKey = `${item.itemName} ${item.description}`;
                    item.selected = false;
                    item.trimmedItemName = item.itemName.trim().replace(/\s/g, "")
                    return item;
                });
                this.remainingResult = response.remainingResult;
            }catch(error){
                this.showToast("Something went wrong! - getting Item", "error");
            }
        },
    }
}
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeDepartment="getCartItems($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="item-request-modal"
            title="Item Request"
            size="lg"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <b-tabs
                pills
                vertical
                nav-class="p-0"
                nav-wrapper-class="col-sm-3"
                content-class="pt-0 px-2 text-muted border-start"
                v-model="activeTab"
            >
                <b-tab title-item-class="mb-2">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="bx bx-receipt"></i>
                        </span>
                        <span class="d-none d-sm-inline-block"
                            ><i class="bx bx-receipt me-1"></i> Request Form</span
                        >
                    </template>
                    <form
                        @submit.prevent="onCreate"
                        class="needs-validation mx-2"
                        ref="fcForm"
                    >
                        <div class="mb-3">
                            <label for="itemName">Item Name</label>
                            <input
                                autocomplete="off"
                                id="itemName"
                                type="text"
                                v-model="form.itemName"
                                placeholder="Enter Item Name..."
                                class="form-control"
                                :class="{ 'is-invalid': submitted && $v.form.itemName.$error}"
                            />
                            <div v-if="submitted && $v.form.itemName.$error" class="invalid-feedback">
                                <span v-if="!$v.form.itemName.required">This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="description">Specifications</label>
                            <textarea
                                id="description"
                                type="text"
                                v-model="form.description"
                                placeholder="Enter Specifications..."
                                class="form-control"
                                :class="{ 'is-invalid': submitted && $v.form.description.$error}"
                            ></textarea>
                            <div v-if="submitted && $v.form.description.$error" class="invalid-feedback">
                                <span v-if="!$v.form.description.required">This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="unitId">Unit </label>
                            <b-input-group>
                                <template #append>
                                    <b-button
                                        @click="getUnit"
                                        variant="outline-info"
                                    >
                                        <i class="mdi mdi-clipboard-text-search-outline"></i>
                                    </b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    disabled
                                    placeholder="Search Unit..."
                                    class="form-control"
                                    :class="{'is-invalid': submitted && $v.form.unitId.$error}"
                                    v-model="unit"
                                />
                            </b-input-group>
                            <div v-if="submitted && $v.form.unitId.$error" class="invalid-feedback">
                                <span v-if="!$v.form.unitId.required">This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="itemCategoryId"
                                >Item Category
                            </label>
                            <b-input-group>
                                <template #append>
                                    <b-button
                                        @click="getItemCategory"
                                        variant="outline-info"
                                    >
                                        <i class="mdi mdi-clipboard-text-search-outline"></i>
                                    </b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    disabled
                                    placeholder="Search Item Category..."
                                    class="form-control"
                                    :class="{ 'is-invalid': submitted && $v.form.itemCategoryId.$error}"
                                    v-model="itemCategory"
                                />
                            </b-input-group>
                            <div v-if="submitted && $v.form.itemCategoryId.$error" class="invalid-feedback">
                                <span v-if="!$v.form.itemCategoryId.required">This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="subType">Sub Type</label>
                            <select
                                class="form-select"
                                id="subType"
                                v-model="form.subType"
                                placeholder="Select Sub Type..."
                                :class="{ 'is-invalid': submitted && $v.form.subType.$error}"
                            >
                                <option></option>
                                <option value="Goods">Goods</option>
                                <option value="Services">Goods (General Support Services)</option>
                                <option value="Consultancy">Consulting Services</option>
                                <option value="Infrastructure">Infrastructure Projects</option>
                            </select>
                            <div v-if="submitted && $v.form.subType.$error" class="invalid-feedback">
                                <span v-if="!$v.form.subType.required">This value is required.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="unitCost">Unit Cost </label>
                            <masked-input
                                autocomplete="off"
                                id="unitCost"
                                type="text"
                                v-model="form.unitCost"
                                class="form-control text-right"
                                :class="{ 'is-invalid': $v.form.unitCost.$error}"
                                :mask="currencyMask"
                            ></masked-input>
                            <div v-if="submitted && $v.form.unitCost.$error" class="invalid-feedback">
                                <span v-if="!$v.form.unitCost.required">This value is required.</span>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="submit"
                                class="btn btn-primary"
                            >
                                {{this.form.id == 0 ? 'Save' : 'Update'}} changes
                            </button>
                            <button
                                type="button"
                                class="btn btn-link"
                                @click="$bvModal.hide('item-request-modal')"
                            >
                                Close
                            </button>
                        </div>
                    </form>
                </b-tab>
                <b-tab title-item-class="mb-2" @click="getPendingRequest">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="bx bx-receipt"></i>
                        </span>
                        <span class="d-none d-sm-inline-block"><i class="bx bx-list-ol me-1"></i> Pending Request</span>
                    </template>
                    <div>
                        <h5>Pending Request(s)</h5>
                        <RequestItems 
                            :items="pending" 
                            :busy="pendingLoading" 
                            :withActions="true" 
                            @updateItem="updatePendingRI($event, 'pending')" 
                            @deleteItem="deletePendingRI($event, 'pending')"
                        />
                    </div>
                </b-tab>
                <b-tab title-item-class="mb-2" @click="getApprovedRequest">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="bx bx-receipt"></i>
                        </span>
                        <span class="d-none d-sm-inline-block"><i class="bx bx-list-ol me-1"></i> Approved Request</span>
                    </template>
                    <div>
                        <h5>Approved Request(s)</h5>
                        <RequestItems :items="approved" :busy="approveLoading"/>
                    </div>
                </b-tab>
                <b-tab title-item-class="mb-2" @click="getReturnedRequest">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="bx bx-receipt"></i>
                        </span>
                        <span class="d-none d-sm-inline-block position-relative"><i class="bx bx-list-ol me-1"></i> Returned Request<small class="position-absolute badge bg-danger font-size-10 ms-1" style="right:-12px;" v-if="returnCount > 0">{{returnCount}}</small></span>
                    </template>
                    <div>
                        <h5>Returned Request(s)</h5>
                        <RequestItems 
                            :items="returned" 
                            :busy="returnedLoading" 
                            :returned="true" 
                            @updateItem="updatePendingRI($event, 'returned')"
                            @repostItem="repostItem"
                            @viewLog="viewLog"
                            @deleteItem="deletePendingRI($event, 'returned')"
                        />
                    </div>
                </b-tab>
            </b-tabs>
        </b-modal>
        <b-modal
            id="cart-items-modal"
            title="Cart Items"
            size="lg"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <CartItems 
                :items="carts" 
                :withActions="true" 
                @deleteItem="deleteItem"
            />
        </b-modal>
        <ItemCards 
            :items="tableData" 
            :busy="tableBusy" 
            :categories="categories"
            :selectMultiple="!viewOnly" 
            :viewOnly="viewOnly"
            :carts="carts"
            @request-item="requestItem" 
            @select-item="selectedItem" 
            @show-cart="showCart"
            :returnCount="returnCount"
            :remainingResult="remainingResult"
            @search-item="searchAction"
            :loadingMore="loadingMore"
            @load-more="loadMoreItems"
        />
        <unit ref="unit" @dropData="dropUnit($event)"></unit>
        <item-category @dropData="dropItemCat($event)"></item-category>
        <div class="position-fixed" style="bottom:50px;right:50px;">
            <div
                class="position-relative"
                v-if="selectedAvailableItems.length != 0 "
            >
                <button
                    class="
                        btn btn-success
                        d-flex
                        align-items-center
                        rounded-pill
                        hover-max-width
                    "
                    type="button"
                    @click="addToCart"
                >
                    <i class="bx bx-cart font-size-18"></i
                    ><span>Add to Cart</span>
                </button>
                <small
                    class="position-absolute badge bg-danger"
                    style="top: -5px; right: -5px; z-index: 10px"
                    >{{ selectedAvailableItems.length }}</small
                >
            </div>
        </div>
        <item-logs ref="itemLogs"></item-logs>
    </Layout>
</template>